import { render, staticRenderFns } from "./Balancete.vue?vue&type=template&id=ecdbd44a&scoped=true"
import script from "./Balancete.vue?vue&type=script&lang=js"
export * from "./Balancete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdbd44a",
  null
  
)

export default component.exports